import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import type { Database } from '../types/database';

// Environment variables using Vite pattern
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing Supabase environment variables. Please check your .env file and ensure VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are set.'
  );
}

// Create Supabase client with prod schema requirement
export type ProdSupabaseClient = SupabaseClient<Database>;

export const supabase: ProdSupabaseClient = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  db: {
    schema: 'prod'
  },
  global: {
    headers: {
      'X-Client-Info': 'bam-web-ui@0.0.0'
    }
  }
});

export default supabase;
